import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/admin/Sidebar';
import TabBar from '../components/admin/TabBar';
import TopBar from '../components/admin/TopBar';

export default function AdminLayout() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="admin-shell">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />

      <div className="admin-body">
        <TopBar />
        <TabBar />
        <main className="admin-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
